module.exports = __webpack_public_path__ + "img/phone3.7d8616b0.png";